export const OccurrenceClosing = () => (
  <span>Este acionador não necessita de configuração.</span>
)
